import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin, Tooltip } from 'antd'
import AddCoach from './add'
import EditCoach from './edit'
import DeleteCoach from './delete'
import CoachRibbon from './ribbon'
import MyIcon from '../../components/general/icon'

export default function Coach() {
  const [coachData, setCoachData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isAddCoachVisible, setIsAddCoachVisible] = useState(false)
  const [isEditCoachVisible, setIsEditCoachVisible] = useState(false)
  const [isDeleteCoachVisible, setIsDeleteCoachVisible] = useState(false)

  const initialConditions = {
    keywords: '',
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getCoachData = () => {
    axios.post('/admin/content/coach/list/get', { 
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setCoachData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'coachs': response.data.coachs
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getCoachData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, currentPage])

  const editCoach = (oid) => {
    setIsEditCoachVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteCoach = (oid, name) => {
    setIsDeleteCoachVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">教练风采</div>
            <CoachRibbon
              filterValue={filterValue} 
              setFilterValue={setFilterValue} 
              isAddVisible={() => { setIsAddCoachVisible(true) }}  
            />
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th style={{width: '300px'}}>
                      <div className='public-main-style2-title'>名称</div>
                    </th>
                    <th>个人摘要</th>
                    <th>排序</th>
                    <th style={{width: '50px'}}></th>
                  </tr>
                </thead>

                <tbody>
                  {coachData.coachs && (coachData.coachs.length > 0 ? (coachData.coachs.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editCoach(item.oid) }}>
                      <td style={{width: '300px'}}>
                        <div className='public-main-style2-tuwen'>
                          <img src={item.avatar_url} alt="" style={{width: '30px', height: '30px'}}/>
                          <span>{item.name}</span>
                        </div>
                      </td>
                      <td style={{width: '300px'}}>
                        <div className='public-main-style2-abstract'>{item.abstract}</div>
                      </td>
                      <td>{item.sort}</td>
                      <td style={{width: '50px'}}>
                        <div className='public-main-style2-operation-box'>
                          <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                            <div className='public-main-style2-operation' 
                              onClick={(event) => {event.stopPropagation(); deleteCoach(item.oid, item.name)}}>
                              <MyIcon name='huishouzhan' />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='4'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={coachData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>

        {isAddCoachVisible && <AddCoach
          getCoachData={getCoachData} 
          isOpen={isAddCoachVisible} 
          isCancel={() => { setIsAddCoachVisible(false) }} 
        />}

        {isEditCoachVisible && <EditCoach
          data={propsData}
          getCoachData={getCoachData} 
          isOpen={isEditCoachVisible} 
          isCancel={() => { setIsEditCoachVisible(false) }} 
        />}

        {isDeleteCoachVisible && <DeleteCoach
          data={propsData}
          getCoachData={getCoachData} 
          isOpen={isDeleteCoachVisible} 
          isCancel={() => { setIsDeleteCoachVisible(false) }} 
        />}
      </Spin>
    </div>
  )
}
